import { useAuth0 } from "@auth0/auth0-react";
import React from "react";

const LoginButton = () => {
  const { loginWithRedirect, isAuthenticated, logout, user } = useAuth0();

  if (isAuthenticated) {
    return (
      <div className="flex items-center">
        <span className="mr-2">Welcome, {user?.name || user?.email}</span>
        <button 
          onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
          className="bg-red-500 hover:bg-red-600 text-white font-medium py-2 px-4 rounded"
        >
          Log Out
        </button>
      </div>
    );
  }

  return (
    <button 
      onClick={() => loginWithRedirect()}
      className="w-full bg-[#42459b] hover:bg-[#343778] text-white font-medium py-2 px-4 rounded"
    >
      Login with Auth0
    </button>
  );
};

export default LoginButton;
